<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close (click)='onCancel()' 
  cdkFocusInitial>Close</button>
</div>
